import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { NumberParam, useQueryParam } from 'use-query-params';

import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { setLandingDataThunk } from 'store/itinerariesItem/thunks';
import { IPage, IProposal } from 'utils/itineraryDetails/types';

import { getOriginTitle } from '../../Page/Landing/utils';
import { CONTENT_PAGE_PREVIEW_PARAM_NAME } from '../../PageTypes/shared/ApplyUpdates/constants';
import { getPagesWithPlaceholders } from './utils';

function useInlineEditor(itinerary: IProposal) {
  const dispatch = useDispatch();
  const itineraryPages = getPagesWithPlaceholders(itinerary?.landing?.pages || []);

  const checkTitle = (pages: IPage[]) => {
    return pages.map((page) => {
      if (!page.title) {
        return { ...page, title: page?.headline };
      }

      return page;
    });
  };

  useEffect(() => {
    dispatch(setLandingDataThunk({ pages: checkTitle(itineraryPages) }, { isLocalUpdate: true }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useInlineEditor;

export function useContentPagePreview() {
  const [pageId] = useQueryParam(CONTENT_PAGE_PREVIEW_PARAM_NAME, NumberParam);
  const { isTabletOrMobile } = useMediaBreakpoints();

  return {
    withContentPagePreview: !!pageId && !isTabletOrMobile && window.opener !== null,
    pagePreviewId: pageId ?? undefined,
  };
}

/**
 * @param {Object[]} pages - array of pages in proposal landing
 * @param {String[]} navLinks - array of anchor links from left navigation
 * @param {number} pageId - id of updated page preview
 * @returns {null|string}
 */
export function getDefaultActiveAnchor(pages: IPage[], navLinks: string[], pageId: number) {
  const anchorPage = pages.find((p) => p.originalId === pageId);

  if (!anchorPage) return null;

  for (let link of navLinks) {
    const linkTitle = getOriginTitle(link);

    if (linkTitle === anchorPage.headline) return link;
  }

  return null;
}
